module.exports = __webpack_public_path__ + "img/transparency@2x.cfab5da7.png";